// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"04190dd1","548":"62e13f3b","564":"a82aa83b","749":"13764f35","750":"e4c7e274","822":"2e2da3af","826":"39f2380c","937":"509e8384"}[chunkId] + ".1779326379769.chunk.js";
};